<template>
	<div class="wrap-content">
		<div class="middle-wrap">
			<!-- 顶部介绍-搜索 -->
			<div class="u-flex u-row-between u-m-b-36">
				<!-- pc端 -->
				<div class="u-flex u-flex-1 hidden-sm-and-down">
					<span class="cm u-font-28 fw u-relative z-999">千村动态</span>
					<!-- <div class="cont-abs u-font-38">
						CONTENT CENTER
					</div> -->
				</div>
				<!-- 移动端 -->
				<div class="u-flex u-flex-1 hidden-md-and-up">
					<span class="cm fw u-relative z-999 u-font-20">千村动态</span>
					<!-- <div class="cont-abs u-font-20">
						CONTENT CENTER
					</div> -->
				</div>
				<div>
					<el-input placeholder="请输入关键词" prefix-icon="el-icon-search" v-model="query.search" clearable @keyup.enter.native="search"  class="hidden-sm-and-down">
					</el-input>
				</div>

			</div>
			<!-- 文章内容 -->
			<el-row class="cont-wrap" @click.native='goDetail(item)' v-for="item in articleList" :key="item.id">
				<el-col :span="8" class="item-wrap u-relative hidden-sm-and-down">
					<el-image :src="item.article_image" fit="cover" lazy class='el-image'></el-image>
					<div class="occur-time">
						<div class="u-font-28">{{item.content_occur_time.substr(-2)}}</div>
						<div>{{item.content_occur_time}}</div>
					</div>
				</el-col>
				<el-col :span="8" class="item-wrap u-relative hidden-md-and-up">
					<el-image :src="item.article_image" fit="cover" lazy></el-image>
					<div class="occur-time">
						<div class="u-font-18">{{item.content_occur_time.substr(-2)}}</div>
						<div class="u-font-12">{{item.content_occur_time}}</div>
					</div>
				</el-col>
				<el-col :span="16" class="cont-right item-wrap hidden-sm-and-down">
					<div class="cm fw u-line-2 u-font-18">{{item.title}}</div>
					<div class="u-m-t-30 u-font-14 cgray u-line-3" v-html="item.detail_info_list" style="line-height: 1.5;">
			
					</div>
					<div class="u-m-t-24 cgray">
						<van-icon name="clock-o" size="12" color="#7c2326" />
						<span class="u-font-12 u-m-l-4">发布时间: {{moment(item.updated_at).format('YYYY-MM-DD')}}</span>
					</div>
				</el-col>
				<el-col :span="16" class="cont-right item-wrap hidden-md-and-up">
					<div class="cm fw u-line-2 u-font-14">{{item.title}}</div>
					<div class="u-m-t-4 u-font-12 cgray u-line-3" v-html="item.detail_info_list" style="line-height: 1.5;">
				
					</div>
					<div class="cgray">
						<van-icon name="clock-o" class="u-font-12" color="#7c2326" />
						<span class="u-font-12 u-m-l-4">发布时间: {{moment(item.updated_at).format('YYYY-MM-DD')}}</span>
					</div>
				</el-col>
			</el-row>
			
			
			

			<!-- 分页器pc端 每页显示默认的10条-->
			<div class="u-flex u-row-center">
				<el-pagination class="u-m-t-30 hidden-sm-and-down" background layout="prev, pager, next" :total="total" :page-size='query.pageSize' :current-page='query.pageNum' @current-change='currentChange'>
				</el-pagination>
			</div>

			<!-- 分页器移动端  每页显示4条-->
			<div class="u-flex u-row-center">
				<el-pagination class="hidden-md-and-up m-auto" :page-size='query.pageSize' :current-page='query.pageNum' small background
					layout="prev, pager, next" :total="total" @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Content',
		components: {

		},
		data() {
			return {
				articleList:[],
				query:{
					search: '',
					pageNum:1,
					pageSize:5,  
				},
				total:0,
			}
		},
		mounted() {
			this.getArticleList()
		},
		methods: {
			search(){
				this.query.pageNum=1
				this.getArticleList()
			},
			
			async getArticleList(){
				const res=await this.$API.articleList(this.query)
				this.total=res.data.count
				res.data.results.forEach(item=>{
					item.detail_info_list=item.detail_info.replace(/<\/?.+?>/g, "").replace(/&nbsp;/g, " ")
				})
				this.articleList=res.data.results
			},
			// 页数改变
			currentChange(current)	{
				this.query.pageNum=current
				this.getArticleList()
			},
			goDetail(item) {
				localStorage.setItem('article',JSON.stringify(item))
				this.$router.push({
					path: '/detail'
				})
			}
		},
	}
</script>

<style lang="less" scoped>
	.wrap-content {
		.occur-time{
			color: #e1dfdf;
			position: absolute;
			top: 20px;
			left: 16px;
		}
		padding: 26px 0 100px;

		.middle-wrap {
			width: 100%;
			max-width: 1000PX;
			margin: 0 auto;
			box-sizing: border-box;
			.cont-wrap {
				height: 210px;
				// min-height: 120PX;
				margin-bottom: 10PX;
				border-radius: 10PX;
				overflow: hidden;
				cursor: pointer;
			
				.item-wrap {
					height: 100%;
					overflow: hidden;
					.el-image:hover{
						transform: scale(1.2);
					}
					.el-image{
						transition-duration: 0.3s;
					}
				}
			
				.cont-right {
					padding: 18px 10px 0 26px;
					background-color: #fff;
				}
			}

			.cont-abs {
				margin-left: 6px;
				// width: 100%;
				// height: 53px;
				// z-index: 0;
				// position: absolute;
				// left: 20px;
				// top: -8px;
				letter-spacing: 1px;
				color: rgba(216, 216, 216, 0.8);
			}

			/deep/ .el-input__inner {
				width: 250px;
				min-width: 150PX;
				height: 34PX;
				// line-height: 34PX;
				border-radius: 24PX !important;
			}
			/deep/ .el-input__prefix{
				top: -3PX;
			}
			/deep/ .el-input__suffix{
				top: -3PX;
			}
			

			/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #7c2326;
				color: #FFF;
			}

			/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
				color: #fff;
			}

			/deep/ .el-pagination.is-background .el-pager li {

				background-color: rgba(124, 35, 38, .1);
			}
		}
	}
</style>
